import { x } from '@xstyled/styled-components';
import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { select } from '~/lib/select';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaPlayerStore } from './MediaPlayerStore';
import { useGlobalMedia } from './useGlobalMedia';
import { reportSpeedHackAndReload } from '~/lib/reloadDiagnostics';

const selector = (s: MediaPlayerStore) =>
  select(s, 'setPlayer', 'removePlayer');

export const AudioPlayer = () => {
  const { setPlayer, removePlayer } = useMediaPlayerStore(selector);
  const videoRef = useRef<HTMLVideoElement>(null);
  useGlobalMedia();
  useEffect(() => {
    const player = videojs(videoRef.current!, {
      html5: { nativeTextTracks: true },
      autoplay: false,
      controls: false
    });

    setPlayer(player, 'audio');

    const intCheckPlaybackRate = setInterval(() => {
      const playbackRate = videoRef?.current?.playbackRate;

      if (playbackRate !== undefined && playbackRate > 2) {
        reportSpeedHackAndReload(playbackRate, 'audio');
      }
    }, 3000);

    return () => {
      removePlayer(player, 'audio');
      player.dispose();
      clearInterval(intCheckPlaybackRate);
    };
  }, []);

  // The div must be kept here or there is a JS error at the end of the training...
  return (
    <x.div display="none">
      <audio ref={videoRef} crossOrigin="anonymous" />;
    </x.div>
  );
};
